module.exports = __webpack_public_path__ + "assets/img/AfterSale2.dab92b94.png";